import { render, staticRenderFns } from "./CustomEntity.vue?vue&type=template&id=5c7c5cbf&scoped=true&"
import script from "./CustomEntity.vue?vue&type=script&lang=js&"
export * from "./CustomEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c5cbf",
  null
  
)

export default component.exports